import { Divider, Flex, VStack, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';
import Skeleton from 'ui/shared/chakra/Skeleton';
import Tag from 'ui/shared/chakra/Tag';

import { SHARED_LOGS_KEYS } from './i18n';

interface Props {
  methodId: string;
  methodCall: string;
  isLoading?: boolean;
  rightSlot?: React.ReactNode;
}

const Item = ({ label, children, isLoading }: { label: string; children: React.ReactNode; isLoading?: boolean }) => {
  return (
    <Flex
      w="100%"
      columnGap={ 5 }
      rowGap={ 2 }
      px={{ base: 0, lg: 4 }}
      flexDir={{ base: 'column', lg: 'row' }}
      alignItems={{ base: 'flex-start', lg: 'center' }}
    >
      <Skeleton fontWeight={ 600 } w={{ base: 'auto', lg: '80px' }} flexShrink={ 0 } isLoaded={ !isLoading }>
        { label }
      </Skeleton >
      { children }
    </Flex>
  );
};

const LogDecodedInputDataHeader = ({ methodId, methodCall, isLoading, rightSlot }: Props) => {
  const { t } = useI18n();
  const dividerColor = useColorModeValue('#E2E8F0', 'rgba(255, 255, 255, 0.16)');
  const tagBg = useColorModeValue('#F7F7F7', 'whiteAlpha.200');
  const tagColor = useColorModeValue('#4A5568', 'inherit');

  return (
    <VStack
      align="flex-start"
      divider={ <Divider borderColor={ dividerColor }/> }
      fontSize="sm"
      lineHeight={ 5 }
      flexGrow={ 1 }
      w="100%"
    >
      <Flex columnGap={ 2 } w="100%">
        <Item label={ t(SHARED_LOGS_KEYS.fields.methodId) } isLoading={ isLoading }>
          <Tag isLoading={ isLoading } bg={ tagBg } color={ tagColor }>{ methodId }</Tag>
        </Item>
        { rightSlot }
      </Flex>
      <Item label={ t(SHARED_LOGS_KEYS.fields.call) } isLoading={ isLoading }>
        <Skeleton isLoaded={ !isLoading } whiteSpace="pre-wrap" w="100%">{ methodCall }</Skeleton>
      </Item>
    </VStack>
  );
};

export default LogDecodedInputDataHeader;
